import styled, { css } from 'styled-components'

import { AccountSectionNavButton } from '@src/components/AccountSectionNavButton/AccountSectionNavButton'
import { breakpoints } from '@src/constants/breakpoints'

export const ActiveOrdersContainer = styled.div<{ singleorder: boolean }>`
  overflow-y: hidden;
  margin-bottom: 24px;
  overflow-x: hidden;
  max-width: 100%;
`

export const SingleActiveOrderContainer = styled.div`
  flex-direction: column;
  display: flex;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  @media (min-width: ${breakpoints.desktop}px) {
    margin-right: 32px;
  }
`

export const Order = styled(AccountSectionNavButton)<{
  active: boolean
  lastOrder: boolean
  firstOrder: boolean
  oneActiveOrder: boolean
}>`
  all: unset;
  cursor: pointer;
  margin: 0;
  padding: 0;
  border: 2px solid #ebecf0;
  border-radius: 8px;
  margin-right: 16px;
  cursor: pointer;
  overflow: hidden;
  min-width: 300px;
  max-width: 312px;
  width: 100%;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.mainText};

  @media (min-width: ${breakpoints.tablet}px) {
    min-width: 346px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.mainText};
    border-color: ${({ theme }) => theme.colors.brand};
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    h4 {
      color: ${({ theme }) => theme.colors.brand};
    }
  }

  ${({ lastOrder }) =>
    lastOrder &&
    css`
      margin-right: 88px;
    `}

  ${({ firstOrder, oneActiveOrder }) =>
    (firstOrder || oneActiveOrder) &&
    css`
      margin-left: 32px;
    `}
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-right: 32px;
  align-items: center;
`

export const ArrowContainer = styled.div`
  display: flex;

  button {
    margin-left: 8px;
  }
`
export const LoyaltyHeaderContainerBasket = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 8px 4px 8px 0;
  align-items: center;

  button {
    width: 28px;
    height: 28px;
  }
`
